import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MoonMark as Moon } from "@/components/MoonMark";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-noir border border-white/15 px-4 py-3 font-body text-cream placeholder:text-white/30 focus:border-gold focus:outline-none transition-colors";

  return (
    <div className="min-h-screen flex items-center justify-center bg-noir grain relative px-6" data-testid="admin-login-page">
      <div className="relative w-full max-w-md border border-gold/20 bg-noir-2 p-10">
        <div className="text-center mb-8">
          <Moon className="w-8 h-8 text-gold mx-auto mb-4" strokeWidth={1.2} />
          <h1 className="font-serif text-3xl text-cream">Store Owner</h1>
          <p className="font-body text-sm text-white/40 mt-1">After Dark Chocolates · Admin</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <input type="email" required placeholder="Email" value={email} data-testid="admin-email"
            onChange={(e) => setEmail(e.target.value)} className={field} />
          <input type="password" required placeholder="Password" value={password} data-testid="admin-password"
            onChange={(e) => setPassword(e.target.value)} className={field} />
          <button type="submit" disabled={loading} data-testid="admin-login-btn"
            className="w-full py-3.5 bg-gold text-black font-body uppercase tracking-[0.2em] text-xs hover:bg-champagne transition-colors disabled:opacity-50">
            {loading ? "Entering…" : "Enter Dashboard"}
          </button>
        </form>
      </div>
    </div>
  );
}
